import { Card, CardBody } from "reactstrap";
import CopyText from "../Forms/CopyText";
import React from "react";
import fileService from "../../services/fileService";
import MPSButton from "../Buttons/Buttons/MPSButton";
import { DEFAULT_HEIGHT, DEFAULT_WIDTH } from "./TipTap/TiptapImage";
import Messages from "../../Shared/Messages";
import Text from "../Text";

class ImageForHTMl extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  uploadImageForHTML = async e => {
    this.setState({ uploadedImgURL: null, file: null });
    let filesObj = e.target.files;
    if (filesObj && filesObj[0]) {
      this.setState({ file: filesObj[0] });
    }
  };

  uploadFile = async () => {
    let { file } = this.state;
    let type = "IMAGE";
    if (file.type.indexOf("video/") === 0) {
      type = "VIDEO";
    } else if (file.type.indexOf("audio/") === 0) {
      type = "AUDIO";
    }

    let contents = await fileService.uploadFiles(type, file, [], true);
    this.props.addFile({ url: contents[0].contentURL, type });
    this.setState({ file: null });
    document.getElementById("file-element").value = null;
  };

  render() {
    let { existingFiles } = this.props;
    let { file } = this.state;

    return (
      <Card>
        <CardBody>
          <div className="mb-3">
            <Text content={Messages.assets_desc} />
          </div>
          <div className="d-flex justify-content-center">
            <input
              id="file-element"
              type="file"
              accept=".jpg,.jpeg,.png,.gif,.mp3,.mp4,.avi,.aac"
              onChange={this.uploadImageForHTML}
            />
          </div>
          {file && (
            <div className="mt-2 d-flex justify-content-end">
              <MPSButton color="primary" onClick={this.uploadFile}>
                <Text content={Messages.upload} />
              </MPSButton>
            </div>
          )}

          {existingFiles && (
            <div className="mt-3">
              <hr />
              <h6 className="text-center">
                <Text content={Messages.uploaded_files} />
              </h6>
              <div className="d-flex flex-column">
                {existingFiles.map((file, index) => {
                  return (
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      {file.type === "IMAGE" && (
                        <img src={file.url} height={64} className="mr-3" alt={file.name || "Content image"} />
                      )}
                      {file.type === "VIDEO" && (
                        <video controls height="64" preload="none">
                          <source src={file.url} />
                          Sorry, your browser doesn't support embedded videos.
                        </video>
                      )}
                      {file.type === "AUDIO" && (
                        <audio controls src={file.url} preload="none">
                          Sorry, your browser doesn't support embedded videos.
                        </audio>
                      )}

                      {this.props.selectImage ? (
                        <React.Fragment>
                          {file.type === "IMAGE" && (
                            <div className="d-flex justify-content-between">
                              <input
                                className="form-control mx-1"
                                placeholder="Width (Default 300)"
                                type="text"
                                onChange={e => {
                                  this.props.setImageWidth(
                                    index,
                                    e.target.value
                                  );
                                }}
                                value={file.width}
                              />
                              <input
                                className="form-control mx-1"
                                placeholder="Height (Default 300)"
                                type="text"
                                onChange={e => {
                                  this.props.setImageHeight(
                                    index,
                                    e.target.value
                                  );
                                }}
                                value={file.height}
                              />
                            </div>
                          )}
                          <MPSButton
                            onClick={() => {
                              this.props.selectImage(
                                file.url,
                                file.width || DEFAULT_WIDTH,
                                file.height || DEFAULT_HEIGHT
                              );
                            }}
                          >
                            <Text content={Messages.select} />
                          </MPSButton>
                        </React.Fragment>
                      ) : (
                        <div style={{ width: "100%" }} className="ml-2">
                          <CopyText text={file.url} index={index} />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </CardBody>
      </Card>
    );
  }
}

export default ImageForHTMl;
